export const protocolTranslations = {
  SelectProtocolDocuments: 'Protocol 문서 선택',
  ChooseFilesForEachProtocol: '각 Protocol label에 대한 파일을 선택해주세요.',
  SelectFilesForProtocol: 'Protocol용 파일 선택',
  ChooseFilesForLabel: '이 Label에 속하는 파일을 선택해주세요.',
  Required: '필수',
  Optional: '선택',
  ConfirmSelection: '선택 확인',
  StartAutoTagging: '자동 태깅 시작',
  UploadAdditionalFiles: '파일 추가',
  ChooseTheFilesForLabel: '이 Label에 속하는 파일을 선택해주세요.',
}
